@if (!expanded()) {
  <section class="workspace-surface collapsible">
    <button
      type="button"
      class="collapse-section"
      [attr.aria-label]="'requirementIntake.evidence.collapsed.expandLabel' | translate"
      [attr.aria-expanded]="false"
      (click)="expand()"
    >
      <div class="icon">
        <svg viewBox="0 -960 960 960">
          <path
            d="M669.85-320.46q0 76.78-52.69 130.62T488.46-136q-77.92 0-130.42-56.27-52.5-56.27-52.5-135.19v-368.23q0-53.46 36.65-90.89Q378.85-824 432.31-824q54.46 0 90.61 39.92 36.16 39.93 36.16 95.39v345.77q0 29.37-20.62 50.76-20.62 21.39-50 21.39-30.23 0-51.19-22.17-20.96-22.16-20.96-53.98v-342.31h32v346.31q0 16.55 11.41 28.35 11.42 11.8 27.97 11.8 16.56 0 27.97-11.8 11.42-11.8 11.42-28.35v-353.54q.77-39.62-27.2-67.58Q471.92-792 432.11-792q-39.81 0-67.19 29.35-27.38 29.34-27.38 68.96v373.23q.77 63.08 44.31 107.27Q425.38-169 488.46-168t107-45.69q43.92-46.69 42.39-111.77v-363.77h32v368.77Z"
          />
        </svg>
      </div>
      <span translate="requirementIntake.evidence.providedTitle"></span>
      <div class="coverage-track" aria-hidden="true">
        @for (evidence of displayedRequirement()?.evidences; track evidence.id) {
          <span class="coverage-seg {{ evidence.status.toLowerCase() }}"></span>
        }
      </div>
      <span class="coverage-label">
        {{
          'requirementIntake.evidence.coverage.addressed'
            | translate
              : {
                  addressed: evidencesAddressed(),
                  total: displayedRequirement()?.evidences?.length ?? 0,
                }
        }}
      </span>
      <svg class="chevron" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path
          d="M6 9l6 6 6-6"
          stroke="currentColor"
          fill="none"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
  </section>
} @else {
  <section class="workspace-surface evidence-slots">
    <div class="headline">
      <h4 class="surface-title uppercase">{{ 'requirementIntake.evidence.title' | translate }}</h4>
      <div class="coverage">
        <div class="coverage-track" aria-hidden="true">
          @for (evidence of requirement().evidences; track evidence.id) {
            @if (evidence.mandatory || evidence.fileAttachments.length) {
              <span class="coverage-seg {{ evidence.status.toLowerCase() }}"></span>
            }
          }
        </div>
        <span class="coverage-label">
          {{
            'requirementIntake.evidence.coverage.addressed'
              | translate
                : {
                    addressed: evidencesAddressed(),
                    total: mandatoryOrFilePresent(),
                  }
          }}
        </span>
      </div>
      <p class="description">
        {{ 'requirementIntake.evidence.description' | translate }}
      </p>
    </div>
    <div class="slot-list">
      @for (evidence of mandatoryEvidences(); track evidence.id) {
        <comp-evidence-slot-card
          [evidence]="evidence"
          [requirement]="displayedRequirement()"
          [isOtherSlot]="false"
          [isProvided]="isProvided(evidence.id)"
          (uploadSucceeded)="onUploadSucceeded($event)"
          (notProvidedMarked)="onNotProvidedMarked($event)"
          (notifyReloadNeeded)="notifyReloadNeeded.emit($event)"
        ></comp-evidence-slot-card>
      }

      <!-- "Other evidence" catch-all slot always shown at end -->
      <comp-evidence-slot-card
        [evidence]="otherEvidence()"
        [requirement]="displayedRequirement()"
        [isOtherSlot]="true"
        [isProvided]="isProvided(otherEvidence().id)"
        (uploadSucceeded)="onUploadSucceeded($event)"
        (otherEvidenceCreated)="onOtherEvidenceCreated($event)"
        (notProvidedMarked)="onNotProvidedMarked($event)"
        (notifyReloadNeeded)="notifyReloadNeeded.emit($event)"
      ></comp-evidence-slot-card>
    </div>
  </section>
}
